import { Loader } from '@googlemaps/js-api-loader'
import store from '@/store'

function key() {
  const domainUrl = location.href
  if (
    domainUrl.includes('localhost') ||
    domainUrl.includes('staging.backstage.gladmobile.com')
  ) {
    return 'AIzaSyARRJy5eO-KF4Ovii349r3PMhBITHKANv0'
  } else if (
    domainUrl.includes('staging-2.backstage.gladmobile.com') ||
    domainUrl.includes('daisuki.backstage.gladmobile.com') ||
    domainUrl.includes('backstage.gladmobile.com')
  ) {
    return 'AIzaSyBZmEEN1AvjYChnvaG--dIzbnnNwXd1b90'
  } else {
    return 'AIzaSyARRJy5eO-KF4Ovii349r3PMhBITHKANv0'
  }
}

export const mapLoader = (options) => {
  /* HACK: 此處可能有更好的做法，取得store中的資訊 */
  const googlemapLoader = store.state.googlemap.googlemapLoader
  const setGogolemapLoader = store._mutations['googlemap/setGooglemapLoader'][0]
  /* vuex store 已經有map loader，則直接回傳 */
  if (googlemapLoader) {
    return googlemapLoader
  } else {
    /* 建立map loader */
    const loader = new Loader({
      apiKey: key(),
      version: 'weekly',
      language: 'zh-TW',
      ...options,
    })
    /* 將loader放於vuex store，避免重複建立loader */
    setGogolemapLoader(loader)
    return loader
  }
}



// WEBPACK FOOTER //
// ./src/utils/googleMap.js